import Layout from '../../layout';
const specialTopicRouter = {
	path: '/',
	component: Layout,
	redirect: '/',
	name: 'chineseSpecialTopic',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		{
			path: '/special',
			component: () =>
				import('@/pages/chinese/views/speciaNew/index.vue'),
			name: 'special',
		},
		//关于我们
		{
			path: '/aboutUs',
			component: () => import('@/pages/chinese/views/aboutus/index.vue'),
			name: 'aboutUs',
		},
		//论坛
		{
			path: '/luntan2019',
			component: () => import('@/pages/chinese/views/luntan/2019.vue'),
			name: 'luntan2019',
		},
	],
};

export default specialTopicRouter;
